import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Location } from '@angular/common';
import { fadeInOut } from '../../../../../../animations';
import { DefaultFormComponent, FormServiceInterface, UserServiceInterface } from '@hutsix/ngxh6';
import { takeUntil } from 'rxjs/operators';

/**
 * Custom form layout for the SIL/HCS referral follow-up. Groups the flat
 * backend form into the tracker's three decision sections (Company / Client /
 * Outcome) so the page reads like the rest of Quality & Client Care instead
 * of one long list of fields. Selected via `component: 'SilReferralFormComponent'`
 * on the sil_referral FormOptions (forms-config.ts).
 */
@Component({
    selector: 'app-sil-referral-form',
    templateUrl: './sil-referral-form.component.html',
    styleUrls: ['./sil-referral-form.component.scss'],
    animations: [fadeInOut],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SilReferralFormComponent extends DefaultFormComponent {
    constructor(
        @Inject('FormService') public formService: FormServiceInterface,
        @Inject('UserService') public userService: UserServiceInterface,
        public location: Location,
        public cdRef: ChangeDetectorRef,
    ) {
        super(formService, userService, location, cdRef);
    }

    // Referrals are always edited (created by the webhook), so no create
    // redirect — just emit so the detail page refreshes its read model.
    public submit(): void {
        if (this.beforeSubmit && !this.beforeSubmit(this.form.model)) return;
        this.form
            .submit(this.displayToast)
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe({
                next: (res: any) => {
                    this.submitted.emit(res);
                    this.cdRef.detectChanges();
                },
                error: () => this.cdRef.detectChanges(),
            });
    }
}
